import { Trans, useTranslation } from "react-i18next"
import { defaultImportedMatches, defaultProfile } from "../../DefaultEntries"
import { coopRareEnemy_dict, fromBase64, mode_dict, special_dict, useBoolState, useLocalStorage } from "../../Utils"
import { filter_category } from "./BadgeProgress"
import classes from "./Profile.module.css"
import BadgeInfoJson from "../../assets/json/parameters/BadgeInfo.json"
import Modal from "../../components/UI/Modal/Modal"
import { useCallback, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileImport, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { NavLink } from "react-router-dom"
import ModalLoading from "../../components/Modal/Modal"
import Input from "../../components/UI/Input/Input"

const filter_category_progress = ["LimitedRewardLottery", "PlayerRank"]

function badge_image_format(elem) {
    const v = elem.__RowId.replace("Work/Gyml/BadgeInfo", "Badge").replace(".spl__BadgeInfo.gyml", "")
    return `https://leanny.github.io/splat3/images/badge/${v}.png`
}

const BadgeProgressUpdate = props => {
    const { t } = useTranslation()
    const [profile, setProfileData] = useLocalStorage("profile", defaultProfile)
    const [importedData, setImportedData] = useLocalStorage("importedMatches", defaultImportedMatches)
    const [loading, setLoading] = useState(false)

    const [showUploadBox, onOpen, onClose] = useBoolState()
    const [showUploadBoxStatInk, onOpenStatInk, onCloseStatInk] = useBoolState()

    const updateVersusWinCountByRule = (key, val) => {
        const original_part = { ...profile.Versus.WinCountByRule }
        original_part[key] = val
        const original = { ...profile, Versus: { ...profile.Versus, WinCountByRule: original_part } }
        setProfileData(original)
    }
    const updateCoopBossKillNum = (key, val) => {
        const original_part = { ...profile.Coop.BossKillNumMap }
        original_part[key] = val
        const original = { ...profile, Coop: { ...profile.Coop, BossKillNumMap: original_part } }
        setProfileData(original)
    }
    const updateWinCount_WeaponSp = (key, val) => {
        const original_part = { ...profile.Versus.WinCountBySpecial }
        original_part[key] = val
        const original = { ...profile, Versus: { ...profile.Versus, WinCountBySpecial: original_part } }
        setProfileData(original)
    }
    const updateCoopRareEnemyKillNum = (key, val) => {
        const original_part = { ...profile.Coop.RareEnemyKillNumMap }
        original_part[key] = val
        const original = { ...profile, Coop: { ...profile.Coop, RareEnemyKillNumMap: original_part } }
        setProfileData(original)
    }
    const updateWinCount_Tcl = (key, val) => {
        const original_part = { ...profile.Versus }
        original_part["WinCountByTcl" + key] = val
        const original = { ...profile, Versus: original_part }
        setProfileData(original)
    }

    const get_elemUpdate = (entry, idx) => {
        const babse_str = t(
            "translation:CommonMsg.Badge.BadgeMsg." + (entry.MsgLabelEx === "" ? entry.Name : entry.MsgLabelEx)
        )
        switch (entry.Category) {
            case "CoopBossKillNum":
                return (
                    <ElemUpdate
                        value={profile.Coop.BossKillNumMap[coopRareEnemy_dict[entry.Sub1_Str]] ?? 0}
                        setter={val => updateCoopBossKillNum(coopRareEnemy_dict[entry.Sub1_Str], val)}
                        label={babse_str
                            .replace("x 10", "")
                            .replace(
                                "[group=0004 type=0007 params=00 00 00 00]",
                                t("translation:CommonMsg.Coop.CoopEnemy." + entry.Sub1_Str)
                            )}
                        key={idx}
                        raw={entry}
                    />
                )
            case "CoopRareEnemyKillNum":
                return (
                    <ElemUpdate
                        value={profile.Coop.RareEnemyKillNumMap[coopRareEnemy_dict[entry.Sub1_Str]] ?? 0}
                        setter={val => updateCoopRareEnemyKillNum(coopRareEnemy_dict[entry.Sub1_Str], val)}
                        label={babse_str
                            .replace("x 100", "")
                            .replace(
                                "[group=0004 type=0007 params=00 00 00 00]",
                                t("translation:CommonMsg.Coop.CoopEnemy." + entry.Sub1_Str)
                            )}
                        key={idx}
                        raw={entry}
                    />
                )
            case "WinCount_WeaponSp":
                return (
                    <ElemUpdate
                        value={profile.Versus.WinCountBySpecial[entry.Sub1_Int] ?? 0}
                        setter={val => updateWinCount_WeaponSp(entry.Sub1_Int, val)}
                        label={babse_str
                            .replace("30", "")
                            .replace(
                                "[group=0004 type=0001 params=00 00 00 00]",
                                t(
                                    "translation:CommonMsg.Weapon.WeaponName_Special." +
                                        special_dict[entry.Sub1_Int].__RowId
                                )
                            )}
                        key={idx}
                        raw={entry}
                    />
                )
            case "WinCount_Tcl":
                let score = 0
                if (entry.Sub1_Str === "Atk") score = profile.Versus.WinCountByTclAtk ?? 0
                if (entry.Sub1_Str === "Def") score = profile.Versus.WinCountByTclDef ?? 0
                return (
                    <ElemUpdate
                        value={score}
                        setter={val => updateWinCount_Tcl(entry.Sub1_Str, val)}
                        label={babse_str}
                        key={idx}
                        raw={entry}
                    />
                )
            case "WinCount":
                return (
                    <ElemUpdate
                        value={profile.Versus.WinCountByRule[mode_dict[entry.Sub1_Str]] ?? 0}
                        setter={val => updateVersusWinCountByRule(mode_dict[entry.Sub1_Str], val)}
                        label={babse_str.replace("50", "").replace("100", "").trim()}
                        key={idx}
                        raw={entry}
                    />
                )
            default:
                console.log(entry.Category)
                return null
        }
    }

    const onUpload = useCallback(
        newDB => {
            const original_versus = { ...profile.Versus }
            for (const [key, val] of Object.entries(newDB.versus_modes)) {
                original_versus.WinCountByRule[key] = (original_versus.WinCountByRule[key] ?? 0) + val
            }
            for (const [key, val] of Object.entries(newDB.versus_specials)) {
                original_versus.WinCountBySpecial[key] = (original_versus.WinCountBySpecial[key] ?? 0) + val
            }
            original_versus.WinCountByTclAtk = (original_versus.WinCountByTclAtk ?? 0) + newDB.versus_tca
            original_versus.WinCountByTclDef = (original_versus.WinCountByTclDef ?? 0) + newDB.versus_tcd

            const original_coop = { ...profile.Coop }
            for (const [key, val] of Object.entries(newDB.coop_enemy)) {
                original_coop.RareEnemyKillNumMap[key] = (original_coop.RareEnemyKillNumMap[key] ?? 0) + val
            }
            for (const [key, val] of Object.entries(newDB.coop_boss)) {
                original_coop.BossKillNumMap[key] = (original_coop.BossKillNumMap[key] ?? 0) + val
            }
            const original = { ...profile, Versus: original_versus, Coop: original_coop }
            setProfileData(original)

            const original_importedData = {
                Versus: [...importedData.Versus, ...newDB.versus_matches],
                Coop: [...importedData.Coop, ...newDB.coop_matches],
            }
            setImportedData(original_importedData)
            onClose()
            onCloseStatInk()
        },
        [importedData.Coop, importedData.Versus, onClose, profile, setImportedData, setProfileData, onCloseStatInk]
    )

    return (
        <>
            <ModalLoading show={loading} />

            <h2>{t("misc:Profile.UpdateProgress")}</h2>
            <hr />
            <h2>{t("misc:Profile.Battle")}</h2>
            <div className={classes.BadgeList}>
                {BadgeInfoJson.filter(
                    elem =>
                        !filter_category.includes(elem.Category) &&
                        !filter_category_progress.includes(elem.Category) &&
                        elem.Name.includes("_Lv00") &&
                        !elem.Category.includes("Coop")
                ).map((entry, idx) => {
                    return get_elemUpdate(entry, idx)
                })}
            </div>
            <h2>{t("translation:LayoutMsg.Cmn_Menu_00.L_BtnFestStage_02-T_BlackText_00")}</h2>
            <div className={classes.BadgeList}>
                {BadgeInfoJson.filter(
                    elem =>
                        !filter_category.includes(elem.Category) &&
                        !filter_category_progress.includes(elem.Category) &&
                        elem.Name.includes("_Lv00") &&
                        elem.Category.includes("Coop")
                ).map((entry, idx) => {
                    return get_elemUpdate(entry, idx)
                })}
            </div>
            <hr />
            <h2>{t("misc:Profile.UploadData")}</h2>
            <div>
                <p>{t("misc:Profile.UpdateDataInstructions")}</p>
                <Modal show={showUploadBox} modalClosed={onClose} wide={true}>
                    <UploadCard onReplace={onUpload} importedData={importedData} setLoading={setLoading} />
                </Modal>
                <button className={classes.Button} onClick={onOpen}>
                    {t("misc:Profile.RawSplatnet")}
                </button>
                <Modal show={showUploadBoxStatInk} modalClosed={onCloseStatInk} wide={true}>
                    <UploadCardStatInk onReplace={onUpload} importedData={importedData} setLoading={setLoading} />
                </Modal>
                <button className={classes.Button} onClick={onOpenStatInk}>
                    stat.ink
                </button>
            </div>
        </>
    )
}

const ElemUpdate = props => {
    const decreaseVal = () => {
        props.setter(props.value - 1)
    }

    const increaseVal = () => {
        props.setter(parseInt(props.value) + 1)
    }

    const setVal = val => {
        props.setter(parseInt(val.target.value))
    }
    return (
        <div className={classes.UpdateInfo}>
            <div className={classes.UpdateImage}>
                <img src={badge_image_format(props.raw)} alt={props.raw.__RowId} />
            </div>
            <div className={classes.UpdateDesc}>{props.label}</div>
            <div className={classes.UpdateProgress}>
                <input
                    value={props.value}
                    maxLength={5}
                    type="text"
                    inputMode="numeric"
                    min={0}
                    max={99999}
                    style={{ width: "5em" }}
                    onChange={setVal}
                />
            </div>
            <div className={classes.UpdateProgressDecrease}>
                <button className={classes.Button} disabled={props.value === 0} onClick={decreaseVal}>
                    -
                </button>
            </div>
            <div className={classes.UpdateProgressIncrease}>
                <button className={classes.Button} onClick={increaseVal}>
                    +
                </button>
            </div>
        </div>
    )
}

const UploadCard = props => {
    const { t } = useTranslation()

    const [errorMsg, setErrorMsg] = useState("")
    const [data, setData] = useState({})

    function isEmpty(obj) {
        return Object.keys(obj).length === 0
    }

    const replaceDB = () => {
        props.onReplace(data)
        setData({})
        setErrorMsg("")
    }

    const singleParseJson = d => {
        let parsed
        try {
            parsed = JSON.parse(d)
            if (typeof parsed !== "object") {
                setErrorMsg(t("misc:Database.ErrorJSONParse"))
                return
            }
        } catch (e) {
            setErrorMsg(t("misc:Database.ErrorJSONParse"))
            return
        }
        return parsed
    }
    const has_id_in_db = id => {
        const dec = fromBase64(id)
        const timestamp = get_timestamp_from_id(id)
        if (dec.startsWith("VsHistory")) {
            return props.importedData.Versus.includes(timestamp)
        } else {
            return props.importedData.Coop.includes(timestamp)
        }
    }

    const get_timestamp_from_id = id => {
        const dec = fromBase64(id)
        if (dec.startsWith("VsHistory")) {
            return dec.split(":")[2].split("_")[0]
        } else {
            return dec.split(":")[1].split("_")[0]
        }
    }

    const parseJSON = async d => {
        props.setLoading(true)

        let files = Array.from(d.target.files).map(file => {
            // Define a new file reader
            let reader = new FileReader()

            // Create a new promise
            return new Promise(resolve => {
                // Resolve the promise after reading file
                reader.onload = () => resolve(reader.result)

                // Read the file as a text
                reader.readAsText(file)
            })
        })

        // At this point you'll have an array of results
        let res = (await Promise.all(files)).map(e => singleParseJson(e)).flat()
        let all_matches = {
            coop_boss: {},
            coop_enemy: {},
            coop_matches: [],
            mode_wins: {},
            versus_matches: [],
            versus_tca: 0,
            versus_tcd: 0,
            versus_modes: {},
            versus_specials: {},
        }
        for (const match of res) {
            try {
                if ("coopHistoryDetail" in match.data) {
                    const currentData = match.data.coopHistoryDetail
                    if (
                        !has_id_in_db(currentData.id) &&
                        (currentData.rule === "REGULAR" ||
                            currentData.rule === "BIG_RUN" ||
                            currentData.rule === "TEAM_CONTEST")
                    ) {
                        if (currentData.bossResult && currentData.bossResult.hasDefeatBoss) {
                            const bossId = fromBase64(currentData.bossResult.boss.id).substring("CoopEnemy-".length)
                            all_matches.coop_boss[bossId] = 1 + parseInt(all_matches.coop_boss[bossId] ?? 0)
                        }
                        for (const enemy of currentData.enemyResults) {
                            const bossId = fromBase64(enemy.enemy.id).substring("CoopEnemy-".length)
                            all_matches.coop_enemy[bossId] =
                                parseInt(enemy.defeatCount) + parseInt(all_matches.coop_enemy[bossId] ?? 0)
                        }
                    }
                    if (!has_id_in_db(currentData.id)) {
                        all_matches.coop_matches.push(get_timestamp_from_id(currentData.id))
                    }
                } else if ("vsHistoryDetail" in match.data) {
                    const currentData = match.data.vsHistoryDetail
                    if (
                        !has_id_in_db(currentData.id) &&
                        !(currentData.rule === "PRIVATE") &&
                        currentData.judgement === "WIN"
                    ) {
                        const rule = currentData.vsRule
                        if (rule.rule === "TRI_COLOR") {
                            switch (currentData.myTeam.tricolorRole) {
                                case "ATTACK1":
                                case "ATTACK2":
                                    all_matches.versus_tca += 1
                                    break
                                case "DEFENSE":
                                    all_matches.versus_tcd += 1
                                    break
                                default:
                                    console.error("Other", currentData)
                                    break
                            }
                        } else {
                            const rule_id = fromBase64(currentData.vsRule.id).substring("VsRule-".length)
                            all_matches.versus_modes[rule_id] = 1 + parseInt(all_matches.versus_modes[rule_id] ?? 0)
                        }
                        const myself = currentData.myTeam.players.filter(e => e.isMyself)[0]
                        if (myself.result.special > 0) {
                            const special = fromBase64(myself.weapon.specialWeapon.id).substring(
                                "SpecialWeapon-".length
                            )
                            all_matches.versus_specials[special] =
                                1 + parseInt(all_matches.versus_specials[special] ?? 0)
                        }
                    }
                    if (!has_id_in_db(currentData.id)) {
                        all_matches.versus_matches.push(get_timestamp_from_id(currentData.id))
                    }
                } else {
                    console.error(match.data)
                }
            } catch (error) {}
        }
        setErrorMsg("")
        setData(all_matches)
        props.setLoading(false)
    }

    return (
        <>
            <div className={classes.CardContent}>{t("misc:Profile.ImportFromSplatnet")}</div>
            <div className={classes.CardContent}>
                <p>
                    <Trans
                        i18nKey="misc:Profile.UploadDataDesc"
                        defaults="You can import your data from raw splatnet files. These files can be obtained with various tools,
                            for example <0>s3s</0>."
                        components={[
                            // eslint-disable-next-line
                            <a href="https://github.com/frozenpandaman/s3s" />,
                        ]}
                    />
                </p>
                <p>
                    <NavLink to="/tutorial">{t("misc:Profile.RawSplatnetImportTutorial")}</NavLink>
                </p>
                <label>
                    <input
                        id="icon-button-file"
                        accept=".json"
                        type="file"
                        multiple={true}
                        style={{ display: "none" }}
                        onChange={parseJSON}
                    />

                    <span className={classes.ButtonDefault}>
                        <FontAwesomeIcon icon={faFileImport} style={{ marginRight: 8 }} />
                        {t("misc:Database.ButtonOpen")}
                    </span>
                </label>
            </div>
            <hr className={classes.Divider} />
            {isEmpty(data) ? (
                errorMsg
            ) : (
                <div style={{ marginTop: 16 }}>
                    <div>
                        <div>
                            {t("misc:Profile.MatchesImport")}:{" "}
                            <strong>{data.versus_matches.length + data.coop_matches.length}</strong>
                        </div>
                    </div>
                </div>
            )}
            <div className={classes.CardContent}>
                <button
                    className={!isEmpty(data) ? classes.ButtonInfo : classes.ButtonDisabled}
                    disabled={isEmpty(data)}
                    onClick={replaceDB}
                >
                    <span style={{ padding: 6 }}>{t("misc:Profile.Update")}</span>
                </button>
            </div>
        </>
    )
}

const UploadCardStatInk = props => {
    const { t } = useTranslation()
    const [currentURL, setCurrentURL] = useState("")
    const [errorMsg, setErrorMsg] = useState("")
    const [data, setData] = useState({})

    function isEmpty(obj) {
        return Object.keys(obj).length === 0
    }

    const get_timestamp_from_id = timestamp => {
        return timestamp.split("+")[0].replaceAll("-", "").replaceAll(":", "")
    }

    const has_id_in_db = (timestamp, type) => {
        const ts = get_timestamp_from_id(timestamp)
        if (type === "vs") {
            return props.importedData.Versus.includes(ts)
        } else {
            return props.importedData.Coop.includes(ts)
        }
    }

    const getData = () => {
        const fetchData = async url => {
            const all_entries = []
            const all_uuids = new Set()
            let current_page = 1
            let added = false
            do {
                url.searchParams.set("page", current_page)
                added = false
                try {
                    const res = await fetch(url)
                    if (!res.ok) {
                        props.setLoading(false)
                        setErrorMsg(res.statusText)
                        return
                    }
                    const dat = await res.json()
                    for (let d of dat) {
                        if (!all_uuids.has(d.uuid)) {
                            all_uuids.add(d.uuid)
                            all_entries.push(d)
                            added = true
                        }
                    }
                    current_page += 1
                } catch (err) {
                    props.setLoading(false)
                    setErrorMsg(err.message)
                    return
                }
            } while (added)
            return all_entries
        }

        const fetchAllData = async username => {
            const url_sr = new URL("https://stat.ink/@" + username + "/salmon3.json?")
            url_sr.searchParams.set("f[lobby]", "!private")
            const all_sr_matches = await fetchData(url_sr)
            if (!all_sr_matches) {
                return
            }
            const url = new URL("https://stat.ink/@" + username + "/spl3/index.json?")
            url.searchParams.set("f[lobby]", "!private")
            url.searchParams.set("f[result]", "win")
            const all_matches = await fetchData(url)
            if (!all_matches) {
                return
            }
            const all_parsed_matches = {
                coop_boss: {},
                coop_enemy: {},
                coop_matches: [],
                mode_wins: {},
                versus_matches: [],
                versus_tca: 0,
                versus_tcd: 0,
                versus_modes: {},
                versus_specials: {},
            }
            for (const match of all_matches) {
                if (!has_id_in_db(match.start_at.iso8601, "vs")) {
                    switch (match.rule.key) {
                        case "tricolor":
                            switch (match.our_team_role.key) {
                                case "attacker":
                                    all_parsed_matches.versus_tca += 1
                                    break
                                case "defender":
                                    all_parsed_matches.versus_tcd += 1
                                    break
                                default:
                                    console.error("Other", match.rule.key)
                                    break
                            }
                            break
                        case "nawabari":
                            all_parsed_matches.versus_modes[0] = 1 + parseInt(all_parsed_matches.versus_modes[0] ?? 0)
                            break
                        case "area":
                            all_parsed_matches.versus_modes[1] = 1 + parseInt(all_parsed_matches.versus_modes[1] ?? 0)
                            break
                        case "yagura":
                            all_parsed_matches.versus_modes[2] = 1 + parseInt(all_parsed_matches.versus_modes[2] ?? 0)
                            break
                        case "hoko":
                            all_parsed_matches.versus_modes[3] = 1 + parseInt(all_parsed_matches.versus_modes[3] ?? 0)
                            break
                        case "asari":
                            all_parsed_matches.versus_modes[4] = 1 + parseInt(all_parsed_matches.versus_modes[4] ?? 0)
                            break
                        default:
                            console.error("Other", match.rule.key)
                            break
                    }
                    if (match.special > 0) {
                        switch (match.weapon.special.key) {
                            case "ultrashot":
                                all_parsed_matches.versus_specials[1] =
                                    1 + parseInt(all_parsed_matches.versus_specials[1] ?? 0)
                                break
                            case "greatbarrier":
                                all_parsed_matches.versus_specials[2] =
                                    1 + parseInt(all_parsed_matches.versus_specials[2] ?? 0)
                                break
                            case "shokuwander":
                                all_parsed_matches.versus_specials[3] =
                                    1 + parseInt(all_parsed_matches.versus_specials[3] ?? 0)
                                break
                            case "missile":
                                all_parsed_matches.versus_specials[4] =
                                    1 + parseInt(all_parsed_matches.versus_specials[4] ?? 0)
                                break
                            case "amefurashi":
                                all_parsed_matches.versus_specials[5] =
                                    1 + parseInt(all_parsed_matches.versus_specials[5] ?? 0)
                                break
                            case "nicedama":
                                all_parsed_matches.versus_specials[6] =
                                    1 + parseInt(all_parsed_matches.versus_specials[6] ?? 0)
                                break
                            case "hopsonar":
                                all_parsed_matches.versus_specials[7] =
                                    1 + parseInt(all_parsed_matches.versus_specials[7] ?? 0)
                                break
                            case "kyuinki":
                                all_parsed_matches.versus_specials[8] =
                                    1 + parseInt(all_parsed_matches.versus_specials[8] ?? 0)
                                break
                            case "megaphone51":
                                all_parsed_matches.versus_specials[9] =
                                    1 + parseInt(all_parsed_matches.versus_specials[9] ?? 0)
                                break
                            case "jetpack":
                                all_parsed_matches.versus_specials[10] =
                                    1 + parseInt(all_parsed_matches.versus_specials[10] ?? 0)
                                break
                            case "ultrahanko":
                                all_parsed_matches.versus_specials[11] =
                                    1 + parseInt(all_parsed_matches.versus_specials[11] ?? 0)
                                break
                            case "kanitank":
                                all_parsed_matches.versus_specials[12] =
                                    1 + parseInt(all_parsed_matches.versus_specials[12] ?? 0)
                                break
                            case "sameride":
                                all_parsed_matches.versus_specials[13] =
                                    1 + parseInt(all_parsed_matches.versus_specials[13] ?? 0)
                                break
                            case "tripletornado":
                                all_parsed_matches.versus_specials[14] =
                                    1 + parseInt(all_parsed_matches.versus_specials[14] ?? 0)
                                break
                            case "energystand":
                                all_parsed_matches.versus_specials[15] =
                                    1 + parseInt(all_parsed_matches.versus_specials[15] ?? 0)
                                break
                            case "decoy":
                                all_parsed_matches.versus_specials[16] =
                                    1 + parseInt(all_parsed_matches.versus_specials[16] ?? 0)
                                break
                            case "teioika":
                                all_parsed_matches.versus_specials[17] =
                                    1 + parseInt(all_parsed_matches.versus_specials[17] ?? 0)
                                break
                            default:
                                console.error(match.weapon.special.key)
                        }
                    }
                    all_parsed_matches.versus_matches.push(get_timestamp_from_id(match.start_at.iso8601))
                }
            }
            for (const match of all_sr_matches) {
                if (!has_id_in_db(match.start_at.iso8601, "coop")) {
                    for (const boss of Object.values(match.bosses)) {
                        if (boss.boss.aliases.length === 2) {
                            const bossId = parseInt(boss.boss.aliases[0]) || parseInt(boss.boss.aliases[1])
                            if (bossId < 15) {
                                all_parsed_matches.coop_enemy[bossId] =
                                    parseInt(boss.defeated_by_me) + parseInt(all_parsed_matches.coop_enemy[bossId] ?? 0)
                            }
                        }
                    }
                    if (match.king_salmonid && match.clear_extra) {
                        const bossId =
                            parseInt(match.king_salmonid.aliases[0]) || parseInt(match.king_salmonid.aliases[1])
                        all_parsed_matches.coop_boss[bossId] = 1 + parseInt(all_parsed_matches.coop_boss[bossId] ?? 0)
                    }
                    all_parsed_matches.coop_matches.push(get_timestamp_from_id(match.start_at.iso8601))
                }
            }
            setErrorMsg("")
            setData(all_parsed_matches)
            props.setLoading(false)
        }
        setData({})
        setErrorMsg("")
        props.setLoading(true)
        if (!currentURL) return
        const possibleNames = currentURL.match("[A-Za-z0-9_]{1,15}")
        if (possibleNames.length !== 1 && possibleNames[0]) return
        const username = possibleNames[0]
        fetchAllData(username)
    }

    const replaceDB = () => {
        if (isEmpty(data)) return
        setCurrentURL("")
        props.onReplace(data)
        setData({})
    }

    return (
        <>
            <div className={classes.CardContent}>{t("misc:Profile.ImportFromStatink")}</div>
            <div className={classes.CardContent}>
                <span className={classes.TextTiny}>{t("misc:Profile.StatinkInstruction")}</span>
                <Input
                    title={t("misc:Profile.Username")}
                    changed={e => setCurrentURL(e.target.value)}
                    val={currentURL}
                />
                <button
                    className={!isEmpty(currentURL) ? classes.ButtonInfo : classes.ButtonDisabled}
                    disabled={isEmpty(currentURL)}
                    onClick={getData}
                >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
                {isEmpty(data) ? (
                    errorMsg
                ) : (
                    <div style={{ marginTop: 16 }}>
                        <div>
                            <div>
                                {t("misc:Profile.MatchesImport")}:{" "}
                                <strong>{data.versus_matches.length + data.coop_matches.length}</strong>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <hr className={classes.Divider} />
            <div className={classes.CardContent}>
                <button
                    className={!isEmpty(data) ? classes.ButtonInfo : classes.ButtonDisabled}
                    disabled={isEmpty(data)}
                    onClick={replaceDB}
                >
                    <span style={{ padding: 6 }}>{t("misc:Profile.Update")}</span>
                </button>
            </div>
        </>
    )
}

export default BadgeProgressUpdate
